import { css } from '@emotion/react'
import { type HTMLMotionProps, motion } from 'motion/react'
import { type MouseEvent, cloneElement, forwardRef } from 'react'
import type { MenuItemData } from './types'

export interface MenuItemProps extends Omit<HTMLMotionProps<'button'>, 'onClick'> {
	data: MenuItemData
	onClick?: (
		id: string,
		data: MenuItemData,
		e: MouseEvent<HTMLElement, globalThis.MouseEvent>
	) => void
	isActive?: boolean
}

// 处理菜单项样式的子组件
function MenuItemContent({ data, isActive }: { data: MenuItemData; isActive?: boolean }) {
	if (data.icon) {
		return (
			<>
				{cloneElement(data.icon, {
					...data.icon.props,
					width: '16px',
					height: '16px',
				})}
				{data.title}
			</>
		)
	}

	if (data.iconURL) {
		return (
			<>
				<img
					width={16}
					height={16}
					src={data.iconURL}
					css={css`
						width: 16px;
						height: 16px;
					`}
				/>
				{data.title}
			</>
		)
	}

	return <>{data.title}</>
}

export default forwardRef<HTMLButtonElement, MenuItemProps>(function MenuItem(
	{ data, onClick, isActive, ...props },
	ref
) {
	return (
		<motion.button
			ref={ref}
			type="button"
			role="menuitem"
			tabIndex={isActive ? 0 : -1}
			aria-selected={isActive}
			onClick={(e) => {
				onClick?.(data.id, data, e)
			}}
			{...props}
			css={css`
				display: flex;
				gap: 6px;
				align-items: center;
				background: none;
				border: none;
				width: 100%;
				text-align: left;
				border-radius: 8px;
				padding: 8px;
				cursor: pointer;

				&:hover,
				&:focus,
				&:focus-visible,
				&:active {
					outline: none;
					background: var(--selected-on-body-1);
				}

				${isActive &&
				css`
					background: var(--selected-on-body-1);
				`}
			`}
		>
			<MenuItemContent data={data} isActive={isActive} />
		</motion.button>
	)
})
